import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f6e0192"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "profile-container"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("管理员")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "cell-group-title" }, "常用设置", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "cell-group-title" }, "微博账号", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-gray" }, " 过期时间： ", -1))
const _hoisted_7 = { class: "font-red" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "cell-group-title" }, "抖音账号", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-gray" }, " 过期时间： ", -1))
const _hoisted_11 = { class: "font-red" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "refresh-btn" }, "请在电脑端内重新授权", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "cell-group-title" }, "快手账号", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-gray" }, " 过期时间： ", -1))
const _hoisted_15 = { class: "font-red" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "refresh-btn" }, "请在电脑端内重新授权", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "cell-group-title" }, "客户端信息", -1))
const _hoisted_18 = { class: "copy-right" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("退出账号")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("注销账号")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "cell-group-title" }, "客户端信息", -1))
const _hoisted_22 = {
  class: "copy-right",
  style: {"margin-bottom":"10px"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"10px 20px","font-size":"smaller"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-red" }, " 您确定打开访客动态提醒吗？ 这些动态通常不需要关心，用云雀的自动追粉等功能即可自动回复，"),
  /*#__PURE__*/_createTextVNode("开启后，这些动态也将全部接入对话，您确定打开吗？ ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_switch = _resolveComponent("van-switch")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_skeleton = _resolveComponent("van-skeleton")!
  const _component_bottom_bar = _resolveComponent("bottom-bar")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_nav_bar, { title: "设置" }),
      _createVNode(_component_van_skeleton, {
        title: "",
        avatar: "",
        row: 5,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          (_ctx.worker)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_van_image, {
                  class: "profile-image",
                  width: "45",
                  height: "45",
                  src: _ctx.worker.avatar,
                  round: "",
                  alt: "",
                  onClick: _ctx.clickAvatar
                }, null, 8, ["src", "onClick"]),
                _createTextVNode(" " + _toDisplayString(_ctx.worker.name) + "@" + _toDisplayString(_ctx.companyCode) + " " + _toDisplayString(_ctx.worker.nickname) + " ", 1),
                (_ctx.worker.is_admin)
                  ? (_openBlock(), _createBlock(_component_van_tag, {
                      key: 0,
                      plain: "",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_4,
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              (_ctx.isInspector)
                ? (_openBlock(), _createBlock(_component_van_cell, {
                    key: 0,
                    title: "隐私政策",
                    "is-link": "",
                    to: "tos-viewer"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_van_cell, {
                center: "",
                title: "手机在线"
              }, {
                "right-icon": _withCtx(() => [
                  _createVNode(_component_van_switch, {
                    onChange: _ctx.toggleOnDuty,
                    modelValue: _ctx.isOnDuty,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isOnDuty) = $event)),
                    size: "24"
                  }, null, 8, ["onChange", "modelValue"])
                ]),
                _: 1
              }),
              (_ctx.hasMobilePermission)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_van_cell, {
                      title: "定时上下线",
                      "is-link": "",
                      to: "routine"
                    }),
                    _createVNode(_component_van_cell, {
                      center: "",
                      title: "电脑在线时手机提醒",
                      label: "打开后，电脑在线时手机也提醒，建议关闭"
                    }, {
                      "right-icon": _withCtx(() => [
                        _createVNode(_component_van_switch, {
                          onChange: _ctx.toggleNotifyPCOnline,
                          modelValue: _ctx.isNotifyPCOnline,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isNotifyPCOnline) = $event)),
                          size: "24"
                        }, null, 8, ["onChange", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_cell, {
                      center: "",
                      title: "提醒访客动态（如进网站、关注、点菜单等）",
                      label: "开启后1分钟内多次动态只提醒1次，建议关闭"
                    }, {
                      "right-icon": _withCtx(() => [
                        _createVNode(_component_van_switch, {
                          onChange: _ctx.toggleNotifyUserBehavior,
                          modelValue: _ctx.isNotifyUserBehavior,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isNotifyUserBehavior) = $event)),
                          size: "24"
                        }, null, 8, ["onChange", "modelValue"])
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.expiredWeiboApps.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_5,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expiredWeiboApps, (app) => {
                  return (_openBlock(), _createBlock(_component_van_cell, {
                    key: app.appid,
                    title: app.name
                  }, {
                    label: _withCtx(() => [
                      _hoisted_6,
                      _createElementVNode("span", _hoisted_7, _toDisplayString(app.access_token_expire_time), 1)
                    ]),
                    "right-icon": _withCtx(() => [
                      _createElementVNode("span", {
                        class: "font-green refresh-btn",
                        onClick: ($event: any) => (_ctx.refreshWeibo(app.bind_url))
                      }, "刷新授权", 8, _hoisted_8)
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.expiredDouyinApps.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expiredDouyinApps, (app) => {
                  return (_openBlock(), _createBlock(_component_van_cell, {
                    key: app.appid,
                    title: app.name
                  }, {
                    label: _withCtx(() => [
                      _hoisted_10,
                      _createElementVNode("span", _hoisted_11, _toDisplayString(app.tokens_expire_time), 1)
                    ]),
                    "right-icon": _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.expiredKuaishouApps.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expiredKuaishouApps, (app) => {
                  return (_openBlock(), _createBlock(_component_van_cell, {
                    key: app.appid,
                    title: app.name
                  }, {
                    label: _withCtx(() => [
                      _hoisted_14,
                      _createElementVNode("span", _hoisted_15, _toDisplayString(app.refresh_expires_at), 1)
                    ]),
                    "right-icon": _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.showLogout)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _hoisted_17,
                _createVNode(_component_van_cell, {
                  title: "消息提醒设置",
                  "is-link": "",
                  to: "notification-settings"
                }),
                _createVNode(_component_van_cell, {
                  title: "设备信息",
                  "is-link": "",
                  to: "device-info"
                }),
                _createElementVNode("div", _hoisted_18, "沪ICP备16020673号-6A " + _toDisplayString(_ctx.currentTime), 1),
                _createVNode(_component_van_button, {
                  class: "logout-btn",
                  block: "",
                  onClick: _ctx.logout
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (_ctx.isInspector)
                  ? (_openBlock(), _createBlock(_component_van_button, {
                      key: 0,
                      class: "logout-btn",
                      style: {"margin-top":"10px"},
                      block: "",
                      onClick: _ctx.deactivate
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (!_ctx.showLogout)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _hoisted_21,
                _createVNode(_component_van_cell, {
                  title: "消息提醒设置",
                  "is-link": "",
                  to: "wechat-notification-settings"
                }),
                _createVNode(_component_van_cell, {
                  title: "设备信息",
                  "is-link": "",
                  to: "device-info"
                }),
                _createElementVNode("div", _hoisted_22, " 沪ICP备16020673号-6A " + _toDisplayString(_ctx.currentTime), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_bottom_bar)
    ]),
    _createVNode(_component_van_dialog, {
      show: _ctx.showNotifyUserBehaviorDialog,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showNotifyUserBehaviorDialog) = $event)),
      title: "您确定打开访客动态提醒吗？",
      "show-cancel-button": "",
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isNotifyUserBehavior = false)),
      onConfirm: _ctx.doToggleNotifyUserBehavior
    }, {
      default: _withCtx(() => [
        _hoisted_23
      ]),
      _: 1
    }, 8, ["show", "onConfirm"])
  ], 64))
}